var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountStatement1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10265_14894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5935 2.66602H5.22017C4.89008 2.67475 4.57678 2.8134 4.34834 3.05182C4.1199 3.29025 3.99478 3.60919 4.00017 3.93935V20.0593C3.99478 20.3895 4.1199 20.7084 4.34834 20.9469C4.57678 21.1853 4.89008 21.3239 5.22017 21.3327H18.7802C19.1103 21.3239 19.4236 21.1853 19.652 20.9469C19.8804 20.7084 20.0056 20.3895 20.0002 20.0593V7.94602L14.5935 2.66602ZM14.0002 8.66602V3.89268L18.8668 8.66602H14.0002Z",
    fill: "#013C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7191 8.81674L13.7726 3.43232L19.1035 8.76321L13.7191 8.81674Z",
    fill: "#F6948B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 12.0625L14.5227 13.0511H9L9.28977 12.0625H14.8125ZM12.2216 18.7273L9.10227 14.9091L9.08523 14.1932H10.6364C11.0398 14.1932 11.3835 14.1364 11.6676 14.0227C11.9517 13.9063 12.169 13.733 12.3196 13.5028C12.4702 13.2699 12.5455 12.9773 12.5455 12.625C12.5455 12.1051 12.3892 11.6974 12.0767 11.402C11.7642 11.1037 11.2841 10.9545 10.6364 10.9545H9L9.28977 10H10.6364C11.3295 10 11.8977 10.1151 12.3409 10.3452C12.7869 10.5724 13.1165 10.8849 13.3295 11.2827C13.5455 11.6776 13.6534 12.125 13.6534 12.625C13.6534 13.0767 13.554 13.4929 13.3551 13.8736C13.1591 14.2514 12.8438 14.5554 12.4091 14.7855C11.9773 15.0156 11.4063 15.1307 10.696 15.1307H10.6705L13.5511 18.6591V18.7273H12.2216ZM14.8125 10L14.5227 10.9886L10.1761 10.9545L10.4659 10H14.8125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10265_14894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountStatement1);
export default __webpack_public_path__ + "static/media/Account Statement 1.4bfb182133e9726833ce4b0d8e9e41c7.svg";
export { ForwardRef as ReactComponent };